import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  ILeadDetail,
  selectLeadDetail,
  useGetLeadDetailOnMount,
} from '@user/store/lead'
import {
  IOpportunityDetail,
  selectOpportunityDetail,
  useGetOpportunityDetailOnMount,
} from '@user/store/opportunity'
import { useCleanupEntityContacts } from '../../hooks/useCleanupEntityContacts'

type Params = {
  entityId: number
  entityType: ENTITY_TYPES
}

type Result = {
  detail?: ILeadDetail | IOpportunityDetail
  apiStatus: 'pending' | 'success' | 'fail'
}

export function useData(params: Params) {
  const { entityId, entityType } = params

  const leadDetail = useSelector(selectLeadDetail)
  const leadDetailStatus = useGetLeadDetailOnMount(
    entityType === ENTITY_TYPES.Lead ? entityId : undefined,
  )

  const opportunityDetail = useSelector(selectOpportunityDetail)
  const opportunityDetailStatus = useGetOpportunityDetailOnMount(
    entityType === ENTITY_TYPES.Opportunity ? entityId : undefined,
  )

  const { detail, apiStatus } = useMemo<Result>(
    () =>
      entityType === ENTITY_TYPES.Lead
        ? {
            detail: leadDetail ?? undefined,
            apiStatus: leadDetailStatus,
          }
        : {
            detail: opportunityDetail ?? undefined,
            apiStatus: opportunityDetailStatus,
          },
    [
      entityType,
      leadDetail,
      leadDetailStatus,
      opportunityDetail,
      opportunityDetailStatus,
    ],
  )

  const { extContacts, wwmContacts } = useCleanupEntityContacts(detail)

  return {
    detail,
    apiStatus,
    extContacts,
    wwmContacts,
  }
}
